import React, { useContext, ReactElement } from 'react';
import { Box } from '@wds/box';
import { useSurveyTheme, Helmet } from '@sm/webassets';
import { PageVariants, EnterpriseThankYouContext } from '~app/pages/EnterpriseThankYou';
import getSpageGoogleFontsLink from '~app/helpers/spageGoogleFonts';
import useStyles from './useStyles';

type Props = React.PropsWithChildren<{}>;

function EnterpriseThankYouLayout({ children }: Props): ReactElement {
  const { pageVariant } = useContext(EnterpriseThankYouContext);
  const premiumCustom = pageVariant === PageVariants.premiumCustom;
  const { container } = useStyles({ premiumCustom });
  const theme = useSurveyTheme();
  const spageGoogleFontsLink = getSpageGoogleFontsLink(theme);

  return (
    <Box className={container}>
      <Helmet>
        {premiumCustom && spageGoogleFontsLink ? <link rel="stylesheet" href={spageGoogleFontsLink} /> : null}
      </Helmet>
      {children}
    </Box>
  );
}

export default EnterpriseThankYouLayout;
